import { Step } from '../../../../team-apis/otterdam/step';

export function buildStepItem(step: Step, stepId?: number) {
  return {
    label: `Step ${step.ordinal_letter} - ${step.step_type}`,
    active: step.id === stepId,
    name: step.ordinal_letter,
  };
}
